// extracted by mini-css-extract-plugin
module.exports = {"form":"styles-module--form--WdFE3","description":"styles-module--description--3Vzmi","disclaimer":"styles-module--disclaimer--1RdEH"};